// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__73Uh-","text":"Pagination_text__2ANqB","active":"Pagination_active__RlwOE"};